

const Kontener = ({children,title}:{children:any,title?:string})=>{
    return <div className="font-montserrat mb-4 shadow-2xl p-4 pt-6 m-t-2 border-2 border-gray-800 border-r-0 text-text">
        {title && <div className="text-white text-2xl font-bebasneue mb-4">{title}</div>}
        {children}
    </div>
}

export default Kontener